export function cacheBusted(url: string, version?: string): string {
  if (!version) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}v=${encodeURIComponent(version)}`;
}

export function appendStylesheet(href: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const absolute = new URL(href, window.location.href).href;
    if ([...document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]')].some((l) => l.href === absolute)) {
      resolve();
      return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`CSS laden mislukt: ${href}`));
    document.head.appendChild(link);
  });
}

export function appendScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const absolute = new URL(src, window.location.href).href;
    if ([...document.querySelectorAll<HTMLScriptElement>('script[src]')].some((s) => s.src === absolute)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Script laden mislukt: ${src}`));
    document.head.appendChild(script);
  });
}
